module.exports = __webpack_public_path__ + "images/87d4c34d63a3154fee627ff41ae9b84a.svg";